import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import PropTypes from "prop-types";
import React from "react";
import getClassNameFactory from "../../../../../utilities/classNames";
import classNames from "classnames";
import CardBase from "../CardBase";
import { Rank } from "../../../../../core/types";
import Eyebrow from "../../../../../elements/Eyebrow";
import Heading from "../../../../../elements/Heading";

var TextCardBase = function TextCardBase(_ref) {
  var anchor = _ref.anchor,
      borderless = _ref.borderless,
      description = _ref.description,
      secondaryText = _ref.secondaryText,
      eyebrow = _ref.eyebrow,
      footer = _ref.footer,
      heading = _ref.heading,
      headingRank = _ref.headingRank,
      href = _ref.href,
      largeHeading = _ref.largeHeading,
      size = _ref.size,
      renderContent = _ref.renderContent,
      id = _ref.id;
  var getClassName = getClassNameFactory(TextCardBase.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: classNames(_defineProperty({}, anchor, true))
    })
  }, /*#__PURE__*/React.createElement(CardBase, {
    anchor: anchor,
    id: id,
    borderless: borderless,
    href: href,
    size: size
  }, renderContent( /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "content"
    })
  }, eyebrow ? /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "eyebrow"
    })
  }, /*#__PURE__*/React.createElement(Eyebrow, {
    text: eyebrow
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "body"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "heading"
    })
  }, /*#__PURE__*/React.createElement(Heading, {
    rank: headingRank,
    type: largeHeading ? "l" : "xs"
  }, /*#__PURE__*/React.createElement("strong", null, heading))), description ? /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "description"
    })
  }, description) : null, secondaryText ? /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "secondaryText"
    })
  }, secondaryText) : null), footer ? /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "footer"
    })
  }, footer) : null))));
};

TextCardBase.displayName = "TextCardBase";
TextCardBase.sizes = CardBase.sizes;
/* eslint-disable max-len */

TextCardBase.propTypes = {
  /**
   * Anchor the eyebrow, heading and description to the top or bottom of the card.
   */
  anchor: PropTypes.oneOf(["bottom", "top"]),

  /**
   * Hide the border
   */
  borderless: PropTypes.bool,

  /**
   * Description text
   */
  description: PropTypes.node,

  /**
   * Secondary text
   */
  secondaryText: PropTypes.node,

  /**
   * Eyebrow text
   */
  eyebrow: PropTypes.string,

  /**
   * Footer. Should be a valid card footer, like ArticleCardFooter.
   */
  footer: PropTypes.node,

  /**
   * Heading text
   */
  heading: PropTypes.string.isRequired,

  /**
   * Heading rank. 1 will render `<h1 />`, and so on. Defaults to 3.
   */
  headingRank: PropTypes.oneOf(Object.values(Rank)),

  /**
   * Card URL
   */
  href: PropTypes.string,

  /**
   * Enable large heading font size
   */
  largeHeading: PropTypes.bool,

  /**
   * A method to wrap the rendered card content. Use to apply a different visual treatment to the content, such as adding a background image. Usage: `renderContent={content => {<div>{content}</div>}}`.
   */
  renderContent: PropTypes.func,

  /**
   * Size of the Card. Will set the minumum height and grow to fit content.
   */
  size: PropTypes.oneOf(TextCardBase.sizes).isRequired,

  /**
   * id to identity component for Selenium Test
   */
  id: PropTypes.string
};
/* eslint-enable max-len */

TextCardBase.defaultProps = {
  anchor: "top",
  headingRank: Rank.Third,
  renderContent: function renderContent(content) {
    return content;
  } // eslint-disable-line react/display-name

};
export default TextCardBase;